import React from 'react'
import AboutBlock from "../components/AboutBlock"
import StatsBlock from '../components/StatsBlock'
import TeamBlock from '../components/TeamBlock'

const About = () => {
  return (
    <>
        <section className="about">
            <AboutBlock/>
            <StatsBlock/>
            <TeamBlock/>
        </section>
    </>
  )
}

export default About